import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsbEnum } from "@/utils/indicatorsEsb";
import { ResumeIndicatorB1Data } from "@/services/esus/indicator/esb/b1/getResumeIndicatorB1";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsbB1ResumeProps = {
	resume: ResumeIndicatorB1Data;
};

export function IndicatorEsbB1Resume({ resume }: Readonly<IndicatorEsbB1ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalCitizensFinished,
		resume.totalCitizens
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos vinculados"
					value={resume.totalCitizens.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos vinculados"
							message="Quantidade de cidadãos vinculados a equipes ESF/EAP e ESB no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos vinculados com consulta programada"
					value={resume.totalCitizensFinishedLinked.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos vinculados com consulta programada"
							message=" "
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de cidadãos vinculados a equipes ESF/EAP com consulta programada <br />
								realizada nos últimos 12 meses anteriores ao fim no período pela <br />
								equipe ESB de referência a equipe ESF/EAP do cidadão
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos não vinculados com consulta programada"
					value={(
						(resume.totalCitizensFinished ?? 0) -
						(resume.totalCitizensFinishedLinked ?? 0)
					).toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos não vinculados com consulta programada"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de cidadãos vinculados a equipes ESF/EAP com consulta programada <br />
								realizada nos últimos 12 meses anteriores ao fim no período por alguma <br />
								equipe ESB que não tem vínculo com a equipe ESF/EAP do cidadão. <br />
								Obs: em casos de cidadãos com consultas programadas realizadas por mais de <br />
								1 equipe, serão contabilizadas as consultas programadas em ambas as equipes.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Classificação"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsbEnum.B1,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Classificação"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de cidadãos com consulta programada nos 12 meses
								anteriores
								<br />
								ao fim do período em relação ao total de cidadãos vinculados a
								ESF e ESB
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
		</Row>
	);
}
